export class StorageHelper<K extends string> {
  private readonly prefix: string

  constructor(prefix = '') {
    this.prefix = prefix
  }

  private generateKey(key: K) {
    return this.prefix ? `${this.prefix}-${key}` : key
  }

  remove = (key: K) => {
    localStorage.removeItem(this.generateKey(key))
  }

  read = <T = unknown>(key: K) => {
    const value = localStorage.getItem(this.generateKey(key))
    try {
      if (value) {
        return JSON.parse(value) as T
      }
    } catch {
      return value
    }
    return ''
  }

  set = (key: K, value?: unknown) => {
    if (!value && value !== 0) {
      this.remove(key)
      return
    }
    localStorage.setItem(this.generateKey(key), JSON.stringify(value))
  }
}
